import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import classNames from "classnames";
import Popup from "reactjs-popup";
import Alert from "react-s-alert";

import isVisible from "../../common-functions/isVisible"
import getPrivileges from "../../common-functions/getPrivileges"
import Subscriptions from "../AdminDashboard/Subscriptions";
import AddMember from "../AdminDashboard/AddMember";
import { getUser } from "../../actions/memberActions";
import { showMemberPopup, hideMemberPopup } from "../../actions/popupActions";
import {
  deleteStripeOrder,
  linkExistingUserToStripeOrder,
  searchExistingUsersForStripeOrder
} from "../../actions/oneShoppingCartActions";
const { getLatestSyncOrderIdSet, getOrderLocalId } = require("./orderHighlightHelpers");
const {
  buildLinkExistingUserPayload,
  buildAddUserPrefillFromOrder,
  canLinkExistingUser,
  formatSecondaryEmails,
  getAddUserOrderLinkSuccessMessage,
  getLinkExistingUserSuccessMessage,
  getOrderLocalId: getLinkOrderLocalId,
  normalizeUserSearchResults,
} = require("./orderUserLinkHelpers");

class OrderList extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isCourseModalOpen: false,
      selectedOrder: null,
      isDetailModalOpen: false,
      selectedOrderDetail: null,
      addUserOrder: null,
      isLinkExistingUserModalOpen: false,
      linkOrder: null,
      linkSearch: "",
      linkUsers: [],
      selectedLinkUserId: "",
      isLinkConfirming: false,
      isLinkSearching: false,
      isLinkSubmitting: false,
      linkError: ""
    };

    this.openCourseModal = this.openCourseModal.bind(this);
    this.closeCourseModal = this.closeCourseModal.bind(this);
    this.openDetailModal = this.openDetailModal.bind(this);
    this.closeDetailModal = this.closeDetailModal.bind(this);
    this.openAddUserModal = this.openAddUserModal.bind(this);
    this.handleCreatedUserForStripeOrder = this.handleCreatedUserForStripeOrder.bind(this);
    this.openLinkExistingUserModal = this.openLinkExistingUserModal.bind(this);
    this.closeLinkExistingUserModal = this.closeLinkExistingUserModal.bind(this);
    this.handleLinkSearchChange = this.handleLinkSearchChange.bind(this);
    this.handleLinkSearchSubmit = this.handleLinkSearchSubmit.bind(this);
    this.handleLinkUserSelect = this.handleLinkUserSelect.bind(this);
    this.showLinkConfirmation = this.showLinkConfirmation.bind(this);
    this.submitLinkExistingUser = this.submitLinkExistingUser.bind(this);
  }

  openCourseModal(order) {
    this.setState({ isCourseModalOpen: true, selectedOrder: order });
    this.props.getUser(order.UserId);
  }

  closeCourseModal() {
    this.setState({ isCourseModalOpen: false });
  }

  openDetailModal(order) {
    this.setState({ isDetailModalOpen: true, selectedOrderDetail: order });
  }

  closeDetailModal() {
    this.setState({ isDetailModalOpen: false });
  }

  openAddUserModal(order) {
    this.setState({ addUserOrder: order });
    this.closeDetailModal();
    this.props.showMemberPopup();
  }

  handleCreatedUserForStripeOrder(createdUser, submittedUser) {
    const order = this.state.addUserOrder;
    if (!order || !createdUser || !createdUser._id) {
      return;
    }

    if (!canLinkExistingUser(order)) {
      Alert.warning("User created, but this Stripe order still needs product review before it can be linked.", {
        effect: "scale",
        onClose: () => {},
      });
      return;
    }

    this.props.linkExistingUserToStripeOrder(
      getLinkOrderLocalId(order),
      buildLinkExistingUserPayload(order, createdUser._id),
      this.props.page || 1
    )
      .then(() => {
        Alert.success(getAddUserOrderLinkSuccessMessage(createdUser, submittedUser), {
          effect: "scale",
          onClose: () => {},
        });
        this.setState({ addUserOrder: null });
        this.props.hideMemberPopup();
      })
      .catch((error) => {
        Alert.warning(error && error.message ? error.message : "User created, but the Stripe order could not be linked.", {
          effect: "scale",
          onClose: () => {},
        });
      });
  }

  openLinkExistingUserModal(order) {
    this.setState({
      isLinkExistingUserModalOpen: true,
      linkOrder: order,
      linkSearch: order.Email && order.Email !== "-" ? order.Email : "",
      linkUsers: [],
      selectedLinkUserId: "",
      isLinkConfirming: false,
      isLinkSearching: false,
      isLinkSubmitting: false,
      linkError: ""
    });
  }

  closeLinkExistingUserModal() {
    this.setState({
      isLinkExistingUserModalOpen: false,
      linkOrder: null,
      linkSearch: "",
      linkUsers: [],
      selectedLinkUserId: "",
      isLinkConfirming: false,
      isLinkSearching: false,
      isLinkSubmitting: false,
      linkError: ""
    });
  }

  handleLinkSearchChange(event) {
    this.setState({ linkSearch: event.target.value });
  }

  handleLinkSearchSubmit(event) {
    event.preventDefault();

    const search = this.state.linkSearch.trim();
    if (!search) {
      this.setState({ linkError: "Enter an email, name, or user id to search." });
      return;
    }

    this.setState({ isLinkSearching: true, linkError: "", linkUsers: [], selectedLinkUserId: "", isLinkConfirming: false });
    this.props.searchExistingUsersForStripeOrder(search)
      .then((result) => {
        this.setState({
          linkUsers: normalizeUserSearchResults(result),
          isLinkSearching: false
        });
      })
      .catch((error) => {
        this.setState({
          isLinkSearching: false,
          linkError: error && error.message ? error.message : "Unable to search users."
        });
      });
  }

  handleLinkUserSelect(userId) {
    this.setState({ selectedLinkUserId: userId, isLinkConfirming: false });
  }

  showLinkConfirmation() {
    if (!this.state.selectedLinkUserId) {
      this.setState({ linkError: "Select one user to link." });
      return;
    }

    this.setState({ isLinkConfirming: true, linkError: "" });
  }

  getSelectedLinkUser() {
    return this.state.linkUsers.find((user) => user._id === this.state.selectedLinkUserId) || null;
  }

  submitLinkExistingUser() {
    const order = this.state.linkOrder;
    const user = this.getSelectedLinkUser();

    if (!order || !user) {
      this.setState({ linkError: "Select one user to link." });
      return;
    }

    if (!canLinkExistingUser(order)) {
      this.setState({ linkError: "This Stripe order needs a product match before it can be linked to an existing user." });
      return;
    }

    this.setState({ isLinkSubmitting: true, linkError: "" });
    this.props.linkExistingUserToStripeOrder(
      getLinkOrderLocalId(order),
      buildLinkExistingUserPayload(order, user._id),
      this.props.page || 1
    )
      .then((result) => {
        Alert.success(getLinkExistingUserSuccessMessage(result), {
          effect: "scale",
          onClose: () => {},
        });
        this.closeDetailModal();
        this.closeLinkExistingUserModal();
      })
      .catch((error) => {
        this.setState({
          isLinkSubmitting: false,
          linkError: error && error.message ? error.message : "Unable to link user."
        });
      });
  }

  handleDeleteOrder(order) {
    const page = this.props.page || 1;
    this.props.deleteStripeOrder(order.Id || order.id, page)
      .then(() => {
        this.closeDetailModal();
      })
      .catch(() => {});
  }

  getProductTypeLabel(purchaseType) {
    switch (purchaseType) {
      case "course":
        return "Course";
      case "subscription":
        return "Subscription";
      case "pas":
        return "Planning and Scanning (PAS)";
      default:
        return "Not identified";
    }
  }

  normalizeOrder(order) {
    const metadata =
      (order.rawSession && order.rawSession.metadata) || order.metadata || {};
    const amountTotal =
      order.amountTotal !== undefined && order.amountTotal !== null
        ? (order.amountTotal / 100).toFixed(2)
        : "";
    const source = order.source || (order.stripeSessionId ? "Stripe" : "");

    return {
      source,
      Id: order.Id || order.id || order.stripeSessionId || order.orderId || "-",
      Email: order.Email || order.email || "-",
      OrderDescription: order.OrderDescription || order.description || "-",
      purchaseType: order.purchaseType || order.PurchaseType,
      stripePriceId: order.stripePriceId || order.StripePriceId || "-",
      CustomerName:
        order.CustomerName ||
        order.customerName ||
        order.email ||
        "No Data Available",
      UserId: order.UserId || order.userId || null,
      userMatch: order.userMatch !== undefined ? order.userMatch : Boolean(order.UserId || order.userId),
      productMatch: order.productMatch !== undefined ? order.productMatch : true,
      OrderedAt: order.OrderedAt || order.orderedAt || order.createdAt,
      ProductName:
        order.ProductName ||
        order.productName ||
        metadata.displayName ||
        order.purchaseType ||
        "No Data Available",
      targetId: order.targetId || order.TargetId || metadata.targetId || "",
      GrandTotal:
        order.GrandTotal !== undefined
          ? order.GrandTotal
          : amountTotal
            ? amountTotal
          : order.total !== undefined && order.total !== null
            ? order.source === "stripe" || order.source === "Stripe"
              ? (order.total / 100).toFixed(2)
              : order.total
            : "",
      OrderChargeStatusType:
        order.OrderChargeStatusType ||
        (order.paymentStatus === "paid" ? "Accepted" : order.paymentStatus) ||
        "No Data Available",
      completed: order.completed,
      fulfillmentStatus: order.fulfillmentStatus,
      fulfillmentError: order.fulfillmentError,
      transactionReason: order.transactionReason || order.reason || "",
      manualReviewReason: order.manualReviewReason || "",
      completionDate: order.completionDate || order.fulfilledAt,
      ClientId: order.ClientId || order.clientId
    };
  }

  renderUnresolvedUserActions(order) {
    return (
      <div className="mt-1">
        <button
          type="button"
          className="btn btn-link p-0 mr-2"
          onClick={() => {
            this.openAddUserModal(order);
          }}
        >
          Add User
        </button>
        <button
          type="button"
          className="btn btn-link p-0"
          onClick={() => {
            this.closeDetailModal();
            this.openLinkExistingUserModal(order);
          }}
        >
          Link Existing User
        </button>
      </div>
    );
  }

  getOrderReason(order) {
    if (order.transactionReason) {
      return order.transactionReason;
    }

    if (order.OrderChargeStatusType === "Manual Review") {
      return order.manualReviewReason || order.fulfillmentError || "";
    }

    return "";
  }

  renderAmount(order) {
    if (!order.GrandTotal) {
      return "-";
    }

    return "$" + order.GrandTotal;
  }

  renderDetailButton(order, label = "View Details", className = "btn btn-link p-0") {
    return (
      <button
        type="button"
        className={className}
        onClick={() => this.openDetailModal(order)}
      >
        {label}
      </button>
    );
  }

  render() {
    const {
			auth
		} = this.props
		const privileges = getPrivileges(auth);
    const isShow = privileges && isVisible(privileges, "order")
    const isEditable = privileges && isVisible(privileges, "members", "edit")
    if(!isShow){
      return <div className="p-5"></div>
    }
    const latestSyncOrderIds = getLatestSyncOrderIdSet(this.props.latestSyncOrderIds);
    const orders = this.props.orders.map((rawOrder, index) => {
      const order = this.normalizeOrder(rawOrder);
      const isNewlySynced = latestSyncOrderIds.has(getOrderLocalId(order));
      const rowKey = `${order.source || "unknown"}-${order.Id || "unknown"}-${index}`;
      let dateCompleted = null;
      if (order.completionDate) {
        dateCompleted = moment(order.completionDate).format("MM-DD-YYYY");
      }
      const orderReason = this.getOrderReason(order);
      return (
        <li
          key={rowKey}
          className={classNames("list-group-item list-group-item-action", {
            "border-left border-info": isNewlySynced,
          })}
          style={isNewlySynced ? { backgroundColor: "#f4fbff", borderLeftWidth: "4px" } : undefined}
        >
          <div className="row">
            {isEditable && <div className="col-2 text-left">
              {order.source ? (
                this.renderDetailButton(order, order.source || "Order Source", "btn btn-link p-0")
              ) : (
                <span>{order.source}</span>
              )}
            </div>}
            <div className={classNames("text-left ", {
              "col-2": isEditable,
              "col-3": !isEditable,
            })}>
              {isEditable && order.UserId ? (
                <div>
                  <span
                    className="btn-link"
                    style={{ cursor: "pointer" }}
                    onClick={() => this.openCourseModal(order)}
                    title="Manage courses for this customer"
                  >
                    {order.CustomerName}
                  </span>
                  {isNewlySynced && (
                    <span className="badge badge-info ml-2">NEW</span>
                  )}
                </div>
              ) : (
                <div>
                  <div>
                    {order.CustomerName}
                    {isNewlySynced && (
                      <span className="badge badge-info ml-2">NEW</span>
                    )}
                  </div>
                  {isEditable && !order.UserId && order.source === "Stripe" && this.renderUnresolvedUserActions(order)}
                </div>
              )}
            </div>
            <div className="col-3 text-right">
              {order.OrderedAt
                ? moment(order.OrderedAt).format("dddd, MMMM Do YYYY")
                : "-"}
            </div>
            <div className="col-3 text-right">
              {order.productMatch ? (
                order.ProductName
              ) : (
                <span className="text-warning">No product match</span>
              )}
            </div>
            <div className="col-2 text-right">
              <strong>{this.renderAmount(order)}</strong>
              <br />
              {order.OrderChargeStatusType === "Accepted" ||
              order.OrderChargeStatusType === "Completed marker" ? (
                <span className="text-success">
                  {order.OrderChargeStatusType}
                </span>
              ) : (
                <span className="text-danger">
                  {order.OrderChargeStatusType}
                </span>
              )}
              <br />

              {orderReason ? (
                <React.Fragment>
                  <span className="text-muted">{orderReason}</span>
                  <br />
                </React.Fragment>
              ) : order.fulfillmentStatus === "user_not_found" ? (
                <React.Fragment>
                  <span className="text-danger">User not found</span>
                  <br />
                </React.Fragment>
              ) : order.OrderChargeStatusType === "Manual Review" && order.fulfillmentError ? (
                <React.Fragment>
                  <span className="text-danger">{order.fulfillmentError}</span>
                  <br />
                </React.Fragment>
              ) : null}

              <div>
                {order.completed === true ? (
                  <i className="fas fa-check-double" />
                ) : (
                  <i className="fas fa-times-circle" />
                )}
              </div>
              <div>{dateCompleted}</div>
              <div className="mt-2">
                {this.renderDetailButton(order, "Details", "btn btn-outline-secondary btn-sm")}
              </div>
            </div>
          </div>
        </li>
      );
    });

    return (
      <div>
        <div className="row">
          {isEditable && <div className="col-2 text-center">Order Source</div>}
          <div className={classNames("text-center", {
            "col-2": isEditable,
            "col-3": !isEditable,
          })}>Customer Name</div>
          {/* <div className="col-1 text-center">Order ID</div> */}
          <div className="col-3 text-center">Date</div>
          <div className="col-3 text-center">Product</div>
          <div className="col-2 text-center">Total / Action</div>
        </div>
        <ul className="list-group">{orders}</ul>
        <Popup
          position="right center"
          modal={true}
          open={this.props.popup.isMemberPopup}
          closeOnDocumentClick
          onClose={() => {
            this.setState({ addUserOrder: null });
            this.props.hideMemberPopup();
          }}
          contentStyle={{
            position: "fixed",
            zIndex: "1",
            height: "100%",
            width: "40vw",
            padding: "30px",
            right: "0",
            top: "0",
            overflowY: "auto"
          }}
          arrow={false}
          closeOnEscape={true}
        >
          <div className="modal-container">
            <AddMember
              initialUser={this.state.addUserOrder ? buildAddUserPrefillFromOrder(this.state.addUserOrder) : null}
              initialUserKey={this.state.addUserOrder ? getLinkOrderLocalId(this.state.addUserOrder) : ""}
              onUserCreated={this.state.addUserOrder ? this.handleCreatedUserForStripeOrder : null}
              suppressSuccessMessage={Boolean(this.state.addUserOrder)}
            />
          </div>
        </Popup>
        <Popup
          position="right center"
          modal={true}
          open={this.state.isLinkExistingUserModalOpen}
          closeOnDocumentClick
          onClose={this.closeLinkExistingUserModal}
          contentStyle={{
            position: "fixed",
            zIndex: "1",
            height: "100%",
            width: "42vw",
            padding: "30px",
            right: "0",
            top: "0",
            overflowY: "auto"
          }}
          arrow={false}
          closeOnEscape={true}
        >
          <div className="modal-container">
            <h2>Link Existing User</h2>
            {this.state.linkOrder && (
              <div className="small mb-3">
                <div><strong>Stripe order/payment id:</strong> {this.state.linkOrder.Id}</div>
                <div><strong>Payment email:</strong> {this.state.linkOrder.Email}</div>
                <div><strong>Product:</strong> {this.state.linkOrder.ProductName}</div>
              </div>
            )}
            <form onSubmit={this.handleLinkSearchSubmit}>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  placeholder="Search by email, first name, last name, or user id"
                  value={this.state.linkSearch}
                  onChange={this.handleLinkSearchChange}
                />
                <div className="input-group-append">
                  <button type="submit" className="btn btn-pp" disabled={this.state.isLinkSearching}>
                    {this.state.isLinkSearching ? "Searching..." : "Search"}
                  </button>
                </div>
              </div>
            </form>
            {this.state.linkError && (
              <div className="alert alert-danger mt-3">{this.state.linkError}</div>
            )}
            <div className="mt-3">
              {this.state.linkUsers.length === 0 ? (
                <div className="text-muted">No users selected or found yet.</div>
              ) : (
                this.state.linkUsers.map((user) => {
                  const secondaryEmails = formatSecondaryEmails(user);
                  return (
                    <label key={user._id} className="border p-2 mb-2 d-block">
                      <input
                        type="radio"
                        name="linkExistingUser"
                        className="mr-2"
                        checked={this.state.selectedLinkUserId === user._id}
                        onChange={() => this.handleLinkUserSelect(user._id)}
                      />
                      <strong>{[user.firstName, user.lastName].filter(Boolean).join(" ") || "Unnamed user"}</strong>
                      <div className="small text-muted">User id: {user._id}</div>
                      <div className="small">Primary Email: {user.email || "-"}</div>
                      {secondaryEmails.length > 0 && (
                        <div className="small">Secondary / Payment Emails: {secondaryEmails.join("; ")}</div>
                      )}
                    </label>
                  );
                })
              )}
            </div>
            {!this.state.isLinkConfirming ? (
              <div className="mt-3">
                <button
                  type="button"
                  className="btn btn-pp mr-2"
                  onClick={this.showLinkConfirmation}
                  disabled={!this.state.selectedLinkUserId}
                >
                  Continue
                </button>
                <button type="button" className="btn btn-secondary" onClick={this.closeLinkExistingUserModal}>
                  Cancel
                </button>
              </div>
            ) : (
              <div className="mt-4">
                <h4>Confirm Link</h4>
                {this.state.linkOrder && (
                  <div className="small">
                    <div><strong>Stripe order/payment id:</strong> {this.state.linkOrder.Id}</div>
                    <div><strong>Payment email:</strong> {this.state.linkOrder.Email}</div>
                    <div><strong>Product:</strong> {this.state.linkOrder.ProductName}</div>
                  </div>
                )}
                {this.getSelectedLinkUser() && (
                  <div className="small mt-2">
                    <div><strong>Selected user:</strong> {[this.getSelectedLinkUser().firstName, this.getSelectedLinkUser().lastName].filter(Boolean).join(" ") || this.getSelectedLinkUser()._id}</div>
                    <div><strong>Primary email:</strong> {this.getSelectedLinkUser().email || "-"}</div>
                    {formatSecondaryEmails(this.getSelectedLinkUser()).length > 0 && (
                      <div><strong>Secondary / payment emails:</strong> {formatSecondaryEmails(this.getSelectedLinkUser()).join("; ")}</div>
                    )}
                  </div>
                )}
                <div className="mt-3">
                  <button
                    type="button"
                    className="btn btn-pp mr-2"
                    onClick={this.submitLinkExistingUser}
                    disabled={this.state.isLinkSubmitting}
                  >
                    {this.state.isLinkSubmitting ? "Linking..." : "Link User"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => this.setState({ isLinkConfirming: false })}
                    disabled={this.state.isLinkSubmitting}
                  >
                    Back
                  </button>
                </div>
              </div>
            )}
          </div>
        </Popup>
        {this.state.selectedOrderDetail && (
          <Popup
            position="right center"
            modal={true}
            open={this.state.isDetailModalOpen}
            closeOnDocumentClick
            onClose={this.closeDetailModal}
            contentStyle={{
              position: "fixed",
              zIndex: "1",
              height: "100%",
              width: "40vw",
              padding: "30px",
              right: "0",
              top: "0",
              overflowY: "auto"
            }}
            arrow={false}
            closeOnEscape={true}
          >
            <div className="modal-container">
              <h2>Order Details</h2>
              <p><strong>Customer:</strong> {this.state.selectedOrderDetail.CustomerName}</p>
              <p><strong>Email:</strong> {this.state.selectedOrderDetail.Email}</p>
              <p><strong>Order ID:</strong> {this.state.selectedOrderDetail.Id}</p>
              <p><strong>Order Description:</strong> {this.state.selectedOrderDetail.OrderDescription}</p>
              <p>
                <strong>Product:</strong>{" "}
                {this.state.selectedOrderDetail.productMatch
                  ? this.state.selectedOrderDetail.ProductName
                  : "No product match"}
              </p>
              <p><strong>Product Type:</strong> {this.getProductTypeLabel(this.state.selectedOrderDetail.purchaseType)}</p>
              <p><strong>Stripe Product/Price ID:</strong> {this.state.selectedOrderDetail.stripePriceId}</p>
              {this.getOrderReason(this.state.selectedOrderDetail) && (
                <p><strong>Reason:</strong> {this.getOrderReason(this.state.selectedOrderDetail)}</p>
              )}
              <hr />
              {!this.state.selectedOrderDetail.userMatch && (
                <div>
                  <p className="text-danger">No user match found for this order.</p>
                  {isEditable && this.state.selectedOrderDetail && this.state.selectedOrderDetail.source === "Stripe" && (
                    this.renderUnresolvedUserActions(this.state.selectedOrderDetail)
                  )}
                </div>
              )}
              {this.state.selectedOrderDetail.userMatch && !this.state.selectedOrderDetail.productMatch && (
                <p className="text-warning">This order could not be linked to a known product.</p>
              )}
              <div className="mt-4">
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => this.handleDeleteOrder(this.state.selectedOrderDetail)}
                >
                  Delete Order
                </button>
              </div>
            </div>
          </Popup>
        )}
        {this.state.selectedOrder && (
          <Popup
            position="right center"
            modal={true}
            open={this.state.isCourseModalOpen}
            closeOnDocumentClick
            onClose={this.closeCourseModal}
            contentStyle={{
              position: "fixed",
              zIndex: "1",
              height: "100%",
              width: "40vw",
              padding: "30px",
              right: "0",
              top: "0",
              overflowY: "auto"
            }}
            arrow={false}
            closeOnEscape={true}
          >
            <div className="modal-container">
              <h2>{this.state.selectedOrder.CustomerName}</h2>
              {this.props.members.member &&
              this.props.members.member._id === this.state.selectedOrder.UserId ? (
                <Subscriptions
                  userID={this.props.members.member._id}
                  courses={this.props.members.member.courses || []}
                  pas={this.props.members.member.pas || {}}
                  subscriptions={this.props.members.member.subscriptions || []}
                />
              ) : (
                <div>Loading...</div>
              )}
            </div>
          </Popup>
        )}
      </div>
    );
  }
}

OrderList.propTypes = {
  orders: PropTypes.array.isRequired,
  latestSyncOrderIds: PropTypes.array
};
const mapStateToProps = state => ({
  auth: state.auth,
  members: state.members,
  popup: state.popup
})
export default connect(
  mapStateToProps,
  {
    getUser,
    showMemberPopup,
    hideMemberPopup,
    deleteStripeOrder,
    linkExistingUserToStripeOrder,
    searchExistingUsersForStripeOrder
  }
)(OrderList);
